<template>
  <router-view />
</template>

<script>
export default {
  name: 'OperationsPublicPortal',
  data() {
    return {
    };
  },
};
</script>
